import { LinkButtonList, LinkList } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { DIRECTION, LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import { marginTop } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  align: LAYOUT_ALIGN.CENTER,
  spacing: LAYOUT_SPACING.LARGE,
})`
  ${marginTop(2)}
`
// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const FooterNav = ({ nav }) => {
  const { primary, secondary } = nav
  return (
    <Layout>
      {primary && (
        <LinkButtonList
          align={LAYOUT_ALIGN.STRETCH}
          pages={primary}
          direction={DIRECTION.VERTICAL}
          spacing={LAYOUT_SPACING.SMALL}
        />
      )}
      {secondary && (
        <LinkList
          align={LAYOUT_ALIGN.STRETCH}
          pages={secondary}
          direction={DIRECTION.VERTICAL}
          spacing={LAYOUT_SPACING.SMALL}
        />
      )}
    </Layout>
  )
}

FooterNav.propTypes = {
  nav: PropTypes.object.isRequired,
}

export default FooterNav
